module.exports = __webpack_public_path__ + "img/isidoors.fcb0d5a4.png";